import { ModalRef } from './modal-ref.model';

export abstract class Modal {
  modalInstance: ModalRef;

  abstract onInjectInputs(inputs: any): void;

  accept(output?: any): void {
    this.modalInstance.accept(output);
  }

  dismiss(): void {
    this.modalInstance.dismiss();
  }
}
